module.exports = __webpack_public_path__ + "site/img/26.aa180feb.jpg";